import { _ModalConfirmacion, IModalConfirmacionConfig } from "./ModalConfirmacion";

export function _ModalSimple(config: Pick<IModalConfirmacionConfig, "DrawContent" | "Message" | "StrModalBotons" | "Title" | "Width" | "LangModuleKeyInContext">) {
    _ModalConfirmacion({
        Title: config.Title,
        Message: config.Message,
        LangModuleKeyInContext: config.LangModuleKeyInContext,
        Width: (config.Width || 400),
        DrawContent: (content, modalThings) => {
            modalThings.Modal._FooterSelection
                .remove();

            if (config.DrawContent) {
                config.DrawContent(content, modalThings);
            }
        },
        StrModalBotons: config.StrModalBotons
    })
}